import Const from 'constants';

const PrioritizeCompletingLineupsAboveExp = {
    setPrioritizeCompletingLineupsAboveExpFromStorage(value) {
        return (dispatch) => {
            dispatch(this.prioritizeCompletingLineupsAboveExp(value, {saveToStorage: false}));
        };
    },

    prioritizeCompletingLineupsAboveExp(value, options = {}) {
        return (dispatch) => {
            const {saveToStorage = true} = options;

            dispatch({
                type: Const.SET_PRIORITIZE_COMPLETING_LINEUPS_ABOVE_EXP_MAX,
                    prioritizeCompletingLineupsAboveExp: Boolean(value),
                });

            saveToStorage && dispatch(
                this.saveDataToStorage('prioritizeCompletingLineupsAboveExp', function (state) {
                    const {filters} = state.lineupsData;

                    return filters.prioritizeCompletingLineupsAboveExp;
                }),
            );
        };
    },
};

export default PrioritizeCompletingLineupsAboveExp;
